import React, { useState } from "react";
import { Badge, Card, Row, Col, Button } from "react-bootstrap";
import { useConversations } from "../contexts/ConversationsProvider";
import { IoChatbubbleEllipses, IoPeople, IoPerson } from "react-icons/io5";
import { useContacts } from "../contexts/ContactsProvider";

export default function Conversations({ id, setIsSelect }) {
  const { conversations, selectConversationIndex } = useConversations();
  const { contacts } = useContacts();
  const [conversationsType, setConversationsType] = useState(0);

  const handleConversationTypeChange = (conversationType) => {
    setConversationsType(conversationType);
  };

  return (
    <div
      className="d-flex h-100 w-100 flex-column"
      style={{
        backgroundColor: "var(--light)",
        // backgroundImage: "url(./pattern-background-1.png)",
      }}
    >
      <div className="d-flex mt-5 mx-5 g-2" style={{ fontSize: "1.5rem" }}>
        مرحبًا ،{localStorage.getItem("chat-app-user-name").slice(1, -1)}
      </div>
      <div className="d-flex mt-2 mx-5 g-2">
        <Button
          type="submit"
          className={conversationsType === 0 ? "app-bold" : "app"}
          style={{
            backgroundColor: "var(--light)",
            height: "100%",
            marginLeft: "2%",
            border: `1px solid ${
              conversationsType === 0 ? "black" : "lightgray"
            }`,
            borderRadius: "2rem",
            color: "var(--dark)",
            fontSize: "1rem",
          }}
          onClick={() => handleConversationTypeChange(0)}
        >
          <IoChatbubbleEllipses
            color={conversationsType === 0 ? "black" : "lightgray"}
            style={{ marginInlineEnd: "0.5rem" }}
          />
          جميع المحادثات
        </Button>
        <Button
          type="submit"
          className={conversationsType === 1 ? "app-bold" : "app"}
          style={{
            backgroundColor: "var(--light)",
            height: "100%",
            marginLeft: "2%",
            border: `1px solid ${
              conversationsType === 1 ? "black" : "lightgray"
            }`,
            borderRadius: "2rem",
            color: "var(--dark)",
            fontSize: "1rem",
          }}
          onClick={() => handleConversationTypeChange(1)}
        >
          <IoPeople
            color={conversationsType === 1 ? "black" : "lightgray"}
            style={{ marginInlineEnd: "0.5rem" }}
          />
          المجموعات
        </Button>
        <Button
          type="submit"
          className={conversationsType === 2 ? "app-bold" : "app"}
          style={{
            backgroundColor: "var(--light)",
            height: "100%",
            marginLeft: "2%",
            padding: "0.5%",
            border: `1px solid ${
              conversationsType === 2 ? "black" : "lightgray"
            }`,
            borderRadius: "2rem",
            color: "var(--dark)",
            fontSize: "1rem",
          }}
          onClick={() => handleConversationTypeChange(2)}
        >
          <IoPerson
            color={conversationsType === 2 ? "black" : "lightgray"}
            style={{ marginInlineEnd: "0.5rem" }}
          />
          المحادثات الفردية
        </Button>
      </div>
      <div className="d-flex h-100 w-100 justify-content-center align-items-center">
        <Row xs={1} s={2} md={3} className="h-100 w-100 g-2">
          {conversations.map((conversation, index) => {
            var contactIndex = -1;
            if (conversation.isGroup == false) {
              const recepientIndex = conversation.recipients.findIndex(
                (user) => user.id !== id
              );
              contactIndex = contacts.findIndex(
                (user) => user.id === conversation.recipients[recepientIndex].id
              );
            }
            if (conversationsType === 1 && conversation.isGroup === true) {
              return (
                <Col
                  key={index}
                  className="d-flex justify-content-center align-items-center my-2"
                >
                  <Card
                    onClick={() => {
                      selectConversationIndex(index);
                      setIsSelect(true);
                    }}
                    className="d-flex justify-content-center align-content-center"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "10em",
                      borderRadius: "1em",
                      boxShadow: "0.5em 0.5px 10px var(--medium)",
                      border: "none",
                      padding: "3px",
                      overflow: "hidden",
                      background:
                        "linear-gradient(180deg, #FFF3AF, #F4E687, #E5A21C, #EEB838, #EBDA46, #FAE8B4, #FFFFFF, #FAE8B4)",
                    }}
                  >
                    <div
                      style={{
                        background: "white",
                        width: "100%",
                        height: "100%",
                        borderRadius: "1em",
                      }}
                      className="fs-1 d-flex justify-content-center align-items-center flex-column p-1"
                    >
                      {/* Pending Messages Badge */}
                      {conversation.notification !== 0 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            marginRight: "1em",
                            marginTop: "1em",
                          }}
                        >
                          <Badge
                            pill
                            style={{
                              background:
                                "linear-gradient(180deg, #FFF3AF, #F4E687, #E5A21C, #EEB838, #EBDA46, #FAE8B4, #FFFFFF, #FAE8B4)",
                              marginLeft: "0.5em",
                            }}
                          >
                            {conversation.notification}
                          </Badge>
                          رسائل جديده
                        </div>
                      )}

                      <div className="d-flex justify-content-center align-items-center flex-column flex-grow-1">
                        <div className="mx-2 d-flex flex-column">
                          {contactIndex !== -1 &&
                          contacts[contactIndex].image !== "" ? (
                            <img
                              src={contacts[contactIndex].image}
                              className="conversations-profile-image"
                              alt={"user-image-" + index}
                            />
                          ) : (
                            <img
                              src={"./blank-user-image.png"}
                              className="conversations-profile-image"
                              alt={"user-image-" + index}
                            />
                          )}
                        </div>
                        <div
                          className="font-weight-bold pt-1"
                          style={{ textAlign: "center", fontSize: "1.2rem" }}
                        >
                          {conversation.chatName}
                        </div>
                        {conversation.isGroup && (
                          <div className="d-flex flex-row">
                            {conversation.recipients.map((r, index) => {
                              const contactIndex = contacts.findIndex(
                                (user) => user.id === r.id
                              );

                              if (
                                contactIndex !== -1 &&
                                contacts[contactIndex].image !== ""
                              ) {
                                return (
                                  <img
                                    alt={"members-images-" + index}
                                    key={"image-" + index}
                                    src={contacts[contactIndex].image}
                                    className="recipients-profile-image"
                                    style={{
                                      zIndex: index,
                                      left: `${4 * index}px`, // Set the left property based on the index
                                      // left: index == 0 ? "-5px" : "0px",
                                    }}
                                  />
                                );
                              } else {
                                return (
                                  <img
                                    alt={"members-images-" + index}
                                    key={"image-" + index}
                                    src={"./blank-user-image.png"}
                                    width="24em"
                                    className="d-flex"
                                    style={{
                                      position: "relative",
                                      borderRadius: "50%",

                                      zIndex: index,
                                      left: `${4 * index}px`, // Set the left property based on the index
                                      // left: index == 0 ? "-5px" : "0px",
                                    }}
                                  />
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            }
            if (conversationsType === 2 && conversation.isGroup === false) {
              return (
                <Col
                  key={index}
                  className="d-flex justify-content-center align-items-center my-2"
                >
                  <Card
                    onClick={() => {
                      selectConversationIndex(index);
                      setIsSelect(true);
                    }}
                    className="d-flex justify-content-center align-content-center"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "10em",
                      borderRadius: "1em",
                      boxShadow: "0.5em 0.5px 10px var(--medium)",
                      border: "none",
                      overflow: "hidden",
                      padding: "3px",
                      background:
                        "linear-gradient(180deg, #FFF3AF, #F4E687, #E5A21C, #EEB838, #EBDA46, #FAE8B4, #FFFFFF, #FAE8B4)",
                    }}
                  >
                    <div
                      style={{
                        background: "white",
                        width: "100%",
                        height: "100%",
                        borderRadius: "1em",
                      }}
                      className="fs-1 d-flex justify-content-center align-items-center flex-column p-1"
                    >
                      {/* Pending Messages Badge */}
                      {conversation.notification !== 0 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            marginRight: "1em",
                            marginTop: "1em",
                          }}
                        >
                          <Badge
                            pill
                            style={{
                              background:
                                "linear-gradient(180deg, #FFF3AF, #F4E687, #E5A21C, #EEB838, #EBDA46, #FAE8B4, #FFFFFF, #FAE8B4)",
                              marginLeft: "0.5em",
                            }}
                          >
                            {conversation.notification}
                          </Badge>
                          رسائل جديده
                        </div>
                      )}

                      <div className="d-flex justify-content-center align-items-center flex-column flex-grow-1">
                        <div className="mx-2 d-flex flex-column">
                          {contactIndex !== -1 &&
                          contacts[contactIndex].image !== "" ? (
                            <img
                              src={contacts[contactIndex].image}
                              className="conversations-profile-image"
                              alt={"user-image-" + index}
                            />
                          ) : (
                            <img
                              src={"./blank-user-image.png"}
                              className="conversations-profile-image"
                              alt={"user-image-" + index}
                            />
                          )}
                        </div>
                        <div
                          className="font-weight-bold pt-1"
                          style={{ textAlign: "center", fontSize: "1.2rem" }}
                        >
                          {conversation.chatName}
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            }
            if (conversationsType === 0) {
              return (
                <Col
                  key={index}
                  className="d-flex justify-content-center align-items-center my-2"
                >
                  <Card
                    onClick={() => {
                      selectConversationIndex(index);
                      setIsSelect(true);
                    }}
                    className="d-flex justify-content-center align-content-center"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "10em",
                      borderRadius: "1em",
                      boxShadow: "0.5em 0.5px 10px var(--medium)",
                      border: "none",
                      overflow: "hidden",
                      padding: "3px",
                      background:
                        "linear-gradient(180deg, #FFF3AF, #F4E687, #E5A21C, #EEB838, #EBDA46, #FAE8B4, #FFFFFF, #FAE8B4)",
                    }}
                  >
                    <div
                      style={{
                        background: "white",
                        width: "100%",
                        height: "100%",
                        borderRadius: "1em",
                      }}
                      className="fs-1 d-flex justify-content-center align-items-center flex-column p-1"
                    >
                      {/* Pending Messages Badge */}
                      {conversation.notification !== 0 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            marginRight: "1em",
                            marginTop: "1em",
                          }}
                        >
                          <Badge
                            pill
                            style={{
                              background:
                                "linear-gradient(180deg, #FFF3AF, #F4E687, #E5A21C, #EEB838, #EBDA46, #FAE8B4, #FFFFFF, #FAE8B4)",
                              marginLeft: "0.5em",
                            }}
                          >
                            {conversation.notification}
                          </Badge>
                          رسائل جديده
                        </div>
                      )}

                      <div className="d-flex justify-content-center align-items-center flex-column flex-grow-1">
                        <div className="mx-2 d-flex flex-column">
                          {contactIndex !== -1 &&
                          contacts[contactIndex].image !== "" ? (
                            <img
                              className="conversations-profile-image"
                              src={contacts[contactIndex].image}
                              alt={"user-image-" + index}
                            />
                          ) : (
                            <img
                              src={"./blank-user-image.png"}
                              className="conversations-profile-image"
                              alt={"user-image-" + index}
                            />
                          )}
                        </div>
                        <div
                          className="font-weight-bold pt-1"
                          style={{ textAlign: "center", fontSize: "1.2rem" }}
                        >
                          {conversation.chatName}
                        </div>
                        {conversation.isGroup && (
                          <div className="d-flex flex-row">
                            {conversation.recipients.map((r, index) => {
                              const contactIndex = contacts.findIndex(
                                (user) => user.id === r.id
                              );

                              if (
                                contactIndex !== -1 &&
                                contacts[contactIndex].image !== ""
                              ) {
                                return (
                                  <img
                                    alt={"members-images-" + index}
                                    key={"image-" + index}
                                    src={contacts[contactIndex].image}
                                    className="recipients-profile-image"
                                    style={{
                                      zIndex: index,
                                      left: `${4 * index}px`, // Set the left property based on the index
                                      // left: index == 0 ? "-5px" : "0px",
                                    }}
                                  />
                                );
                              } else {
                                return (
                                  <img
                                    alt={"members-images-" + index}
                                    key={"image-" + index}
                                    src={"./blank-user-image.png"}
                                    width="24em"
                                    className="d-flex"
                                    style={{
                                      position: "relative",
                                      borderRadius: "50%",

                                      zIndex: index,
                                      left: `${4 * index}px`, // Set the left property based on the index
                                      // left: index == 0 ? "-5px" : "0px",
                                    }}
                                  />
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            } else {
              return null;
            }
          })}
        </Row>
      </div>
    </div>
  );
}
